import { Pipe, type PipeTransform, inject } from '@angular/core';

import { type Observable, of } from 'rxjs';

import { finShare } from '@fcom/rx';
import { LanguageService } from '@fcom/ui-translate';

type DurationLike = {
  days?: number;
  hours: number;
  hoursForDays?: number;
  milliseconds: number;
  minutes: number;
};

/**
 * Transforms the duration object to a human readable format based on translations
 */
@Pipe({
  name: 'finDuration',
  standalone: false,
})
export class DurationPipe implements PipeTransform {
  private languageService = inject(LanguageService);

  transform(dur: DurationLike | null | undefined): Observable<string | undefined> {
    if (!dur) {
      return of(undefined);
    }
    const { hours, minutes } = dur;
    return this.languageService.translate('bookingSearch.duration', [hours, minutes]).pipe(finShare());
  }
}
